import { Button, Card, List, Space, Typography } from 'antd'
import { Profile as ProfileModel } from '../../models/Profile'
import { Profile } from '../profile/Profile'
import { DownloadOutlined, FileOutlined } from '@ant-design/icons'
import { useEffect, useState } from 'react'
import { Invoice } from '../../models/Billing'
import { fetchInvoices } from '../../services/ProfileBillingService'
import dayjs from 'dayjs'
import { Link } from 'react-router-dom'
import i18n from '../../i18n/setupLocalization'
import LocalizationKeys from '../../i18n/LocalizationKeys'

const { Text } = Typography

interface Props {
  profile: ProfileModel
}

export const InvoicesCard = ({ profile }: Props) => {
  const [invoices, setInvoices] = useState<Invoice[] | undefined>()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  useEffect(() => {
    if (!profile.slug) {
      return
    }
    setIsLoading(true)
    fetchInvoices(profile.slug)
      .then((invoices) => {
        setInvoices(invoices)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [profile])

  return (
    <>
      <Card styles={{ body: { padding: 0 } }}>
        <List
          loading={isLoading}
          dataSource={invoices}
          renderItem={(item) => (
            <List.Item style={{ padding: 15 }}>
              <Space className="w-full space-between">
                <Text>{dayjs.unix(item.timestamp).format('D MMM YYYY')}</Text>
                <Space>
                  <Text>{item.amount}</Text>
                  <Link to={item.download ?? ''} target="_blank">
                    <Button icon={<DownloadOutlined />} />
                  </Link>
                </Space>
              </Space>
            </List.Item>
          )}
        />
      </Card>
      <Profile.BillingPortalButton
        profileSlug={profile.slug}
        icon={<FileOutlined />}
        className="w-full"
        style={{ marginTop: 10 }}
      >
        {i18n.t(
          LocalizationKeys.Component.Subscription.InvoicesCard.ViewAllInvoices
        )}
      </Profile.BillingPortalButton>
    </>
  )
}

export type InvoicesCardType = { InvoicesCard: typeof InvoicesCard }
